<template>
  <div>
<!--已交付金额钻取-->
     <div class="filter-header">
       <i class="icon-fanhui icon iconfont" @click="returnPage"></i>
       <!-- <span class="area">{{ region_list[region[0]] }}</span> -->
        <span class="area">{{c_region[0]=='0'?'全部':getCurrentRegion()}}</span>
            <!-- <span class="area">{{c_item=='0'?'全部':getCurrentItem()}}</span> -->
       <span class="time">{{begin_time}}-{{end_time}}</span>
       <i class="icon iconfont icon-shaixuan" @click="filter"></i>
     </div>
    <!--区域筛选新增饼图-->
     <div style="height:190px;">
       <IEcharts :option="pie" style="height:190px;position:relative;top:15px;"></IEcharts>
     </div>
    <!--区域筛选新增饼图-->
    <ul class="field-wrappwe three">
       <li class="field-item">
         <p class="item-value">{{data.count}}个</p>
         <p class="item-name active">已交付数</p>
       </li>
       <li class="field-item">
         <p class="item-value"> <span class="symbol">¥</span>{{data.all_back_money}}<span class="unit">(万)</span></p>
         <p class="item-name">当前列表已回款</p>
       </li>
       <li class="field-item">
         <p class="item-value"> <span class="symbol">¥</span>{{data.all_money}}<span class="unit">(万)</span></p>
         <p class="item-name ">当前列表已签约</p>
       </li>
     </ul>


     <div class="list-wrapper">
        <nodata v-if="!data.data.length"></nodata>
       <div class="list-item" v-for=" (item,index) in data.data" :key="index">

         <!-- <div class="row text">
           <span ><span class="title">交付时间</span>{{ item.reviewed_at == undefined ? '' : item.reviewed_at.slice(0,10) }}</span>
           <span >{{ item.region_name }}</span>
         </div>
         <div class="row text">
           <span><span class="title">最后开票时间</span>{{item.completed_date}}</span>
           <span>{{ item.group_name }}</span>
         </div> -->
          <div class="row text">
           <span ><span class="title">签约时间</span>{{ item.reviewed_at == undefined ? '' : item.reviewed_at.slice(0,10) }}</span>
           <span >{{ item.region_name }}</span>
         </div>
         <div class="row text">
           <span><span class="title">交付时间</span>{{item.completed_date}}</span>
           <span>{{ item.group_name }}</span>
         </div>

         <!--<div class="row text">-->
           <!--&lt;!&ndash;<span>{{ item.name }}</span>&ndash;&gt;-->
           <!--<span>{{ item.g_name }}</span>-->
         <!--</div>-->

         <div class="row text">
           <!--公司名称改为项目名称-->
           <span @click='GoProdetail(item.project_id)'>{{ item.name }}</span>
           <span><span class="title">负责人</span>{{ item.sales }}</span>
         </div>

         <div class="row">

           <div class="row-item">
             <p class="item-value"> <span class="symbol">¥</span> {{ item.b_money == undefined ? '' : (item.b_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
             <p class="item-name">已回款金额</p>
           </div>

           <div class="row-item right">
             <p class="item-value"> <span class="symbol">¥</span> {{ item.p_money == undefined ? '' : (item.p_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
             <p class="item-name">项目金额</p>
           </div>

           <!--<div class="row-item">-->
             <!--<p class="item-value"> <span class="symbol">¥</span> {{ item.money == undefined ? '' : (item.money/10000).toFixed(2) }} <span class="unit">(万)</span></p>-->
             <!--<p class="item-name">已交付金额</p>-->
           <!--</div>-->

         </div>
       </div>
     </div>

     <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

     <!--筛选-->
     <div class="selbox" v-if="isFilter">
       <p>筛选</p>
       <p class="content">
         时间
       </p>
       <ul class="listtime">
         <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
       </ul>
       <p  class="content">
         区域
       </p>
       <ul  class="listtime">
          <li :class="{'true': item.id == c_region[0]}" v-for="item in region_list" @click="onRegionChang(item.id)" :key="item.id" >{{item.name}}</li>
       </ul>
        <!-- <p class="content">
         小组
       </p>
        <ul  class="listtime">
         <li  style="font-size:12px" :class="{'isactive': c_item== item.id}" v-for="item in itemList" @click="onItemChange(item.id)" :key="item.id" >{{item.name}}</li>
       </ul> -->
       <p class="btnyes" @click="confirmFilter">确定</p>
     </div>
  </div>
</template>

<script>
import nodata from '../public/nodata'
import IEcharts from 'vue-echarts-v3/src/lite.js'//引入图表插件
import 'echarts/lib/chart/pie'//饼图
import '../../assets/css/drillStyle.css'
import slotsList from '../../assets/js/slotsList'
import dateChange from '../../mixins/dateChange.js'
import regionChange from '../../mixins/regionChange.js'

export default {
  mixins:[dateChange,regionChange],
  components:{
    nodata,
    IEcharts//echart 图表
  },
  data () {
    return {
      region:[0],
      isFilter:false,

      status:{
        0:'待处理',
        1:'开发中',
        2:'已交付',
        3:'已暂停',
        4:'已关闭',
        5:'已完结',
      }, //状态

      begin_time:null, // 过滤时间
      end_time:null,

      data:{ //总体数据
        data:[],
        // pieData:[],//饼图数据
      },
      pie:{ //各区域筛选
        // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
        legend: {
            width:'60%',
            bottom:'3%',
            icon: 'circle',
            data: [],
            itemGap: 20,
            textStyle: {
                fontSize: 12,
                color: '#333',
            }
        },
        title: [{
            text: '签约总金额',
            x: '49%',
            y: '39%',
            textAlign: 'center',
            textStyle:{
                color:'#333',
                fontSize:'12',
                fontWeight:'400',
            }
        },
        {
            text: '',
            x: '49%',
            y: '45%',
            textAlign: 'center',
            textStyle:{
                color:'#333',
                fontSize:'12',
                fontWeight:'400',
            }
        }],
        series : [{
             center: ['50%', '45%'],
             color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#86E687'],
             hoverAnimation: false, //设置饼图默认的展开样式
             radius: [40, 58],
             name: 'pie',
             type: 'pie',
             selectedMode: 'single',
             selectedOffset: 6, //选中是扇区偏移量
             clockwise: true,
             startAngle: 150,
             // data: [{value:100,name:'北京'},{value:200,name:'上海'},{value:150,name:'深圳'},{value:200,name:'珠海'},{value:100,name:'三亚'},{value:100,name:'成都'}],
             data:[],
             label:{
               normal:{
                 show:true,
                 position:'outside',
                 formatter: "{d}%\n{b} {c}万",
                 textStyle: {
                     fontSize: 10,
                 }
               }
             }
         }]
      },

    }
  },
  methods:{
    returnPage () {
      this.$router.go(-1)
    },
    getData (data) {
      this.$notice.loading()
      this.$http.getHomePageDeliveryDrill(data).then( res => {
        this.data=res.data
        this.pie.series[0].data=res.data.pieData//饼图数据
        // console.log(res.pieData)
        this.$notice.loading(false)
      })
    },

    filter () { //显示过滤
      this.slots = slotsList.Monthslots(this.begin_time,this.end_time)
      this.isFilter = true
      this.$emit('inFilter')
    },

    confirmFilter () { //确定过滤
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      this.region = this.c_region

      let data = {
        begin_time: this.begin_time ,
        end_time: this.end_time,
        region: this.region,
        item:this.c_item
      }
      this.isFilter = false
      this.getData(data)
      this.$emit('noFilter')
      //window.localStorage.setItem('drillData',JSON.stringify(data))
    },

    cancel () { //点击阴影取消
      this.c_region = this.region
      this.isFilter = false
      this.$emit('noFilter')
    },
    GoProdetail(pid){//项目详情页面
      console.log(pid)
      this.$router.push({name:'prodetails',params:{project_id:pid}})
    },
  },
  created () {
    let data =  JSON.parse ( window.localStorage.getItem('drillData') )
    let {  begin_time , end_time  } = data
    this.begin_time = begin_time
    this.end_time = end_time

    this.getData(data)
  },
}
</script>

<style scoped>
.right{
  margin-left: 105px;
}
 .isactive{
    color: #5483D2;
    background: #C9DDFD;
  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/DeliveryAmountDrill.vue